<div
  class="wrapper"
  [class.invisible]="viewOnly && text === null"
  [style.width.px]="inputWidth"
  [style.height.px]="inputHeight"
>
  <div class="dropdown" [class.viewonly]="viewOnly">
    @if (viewOnly && text) {
      <span class="icon">
        <ng-content select="[icon]"></ng-content>
      </span>
    }
    @if (showCurrencyIcon && value && hasSelectedCurrency) {
      <span class="currency-flag-img-icon">
        <div
          class="currency-flag currency-flag-img-size"
          [ngClass]="'currency-flag-' + flagValue?.toLowerCase()"
        ></div>
      </span>
    }
    <input
      #input
      caiPopover
      [target]="tooltip"
      [placement]="'bottom'"
      [modifiers]="tooltipModifiers"
      class="select-trigger"
      [placeholder]="placeholder || ''"
      [class.focused]="this.focused || this.isOpen()"
      [style.width.px]="inputWidth"
      [style.height.px]="inputHeight"
      [class.currency-selector]="isCurrencySelector"
      [class.currency-selector]="isTopCurrencySelector"
      [(ngModel)]="text"
      (focusin)="focused = true"
      (focusout)="focused = false"
      [ngClass]="{ 'ps-5': value && showCurrencyIcon }"
      (keyup.enter)="openDropdown(dropdown, input)"
      (keyup.Space)="openDropdown(dropdown, input)"
      (click)="openDropdown(dropdown, input)"
      (keyup)="filterOption()"
      (blur)="blur()"
      [disabled]="inputDisabled"
      [class.wallet-color]="hoverWalletEffect"
      [readonly]="isReadOnly"
    />
    <ng-template #tooltip>
      <div class="cai-select-tooltip">
        {{ isTextOverflow ? (text | titlecase) : null }}
      </div>
    </ng-template>
    @if (isCurrencySelector || showBlackChevron) {
      <span
        [class.rotate]="this.isOpen()"
        (click)="inputDisabled ? undefined : openDropdown(dropdown, input)"
        [class.caret]="showBlackChevron"
        [class.chevron]="isCurrencySelector"
      >
        @if (isCurrencySelector) {
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="Keyboard arrow down" clip-path="url(#clip0_9381_1513)">
              <path
                id="Vector"
                d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z"
                fill="#758DFF"
              />
            </g>
            <defs>
              <clipPath id="clip0_9381_1513">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        }
        @if (showBlackChevron) {
          <svg
            width="12"
            height="7"
            viewBox="0 0 12 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.37412 6.154L5.37327 6.15366C5.30188 6.12518 5.25743 6.09339 5.22855 6.06451L0.628553 1.46451C0.548151 1.38411 0.5 1.28234 0.5 1.11807C0.5 0.953795 0.548151 0.852022 0.628553 0.771619C0.708955 0.691217 0.810729 0.643066 0.975 0.643066C1.13927 0.643066 1.24104 0.691217 1.32145 0.771619L5.22145 4.67162L5.575 5.02517L5.92855 4.67162L9.82855 0.771619C9.90895 0.691217 10.0107 0.643066 10.175 0.643066C10.3393 0.643066 10.441 0.691217 10.5214 0.771619C10.6018 0.852023 10.65 0.953797 10.65 1.11807C10.65 1.28233 10.6018 1.38411 10.5214 1.46451L5.92145 6.06451C5.86658 6.11938 5.82013 6.14562 5.78303 6.15877L5.78302 6.15876L5.78064 6.15962C5.72225 6.18064 5.65496 6.19307 5.575 6.19307C5.50591 6.19307 5.44006 6.18044 5.37412 6.154Z"
              fill="#4C5459"
              stroke="#4C5459"
            />
          </svg>
        }
      </span>
    }
    @if (!isCurrencySelector && !showBlackChevron) {
      <span
        (click)="
          inputDisabled ? undefined : openDropdown(dropdown, input);
          $event.stopPropagation()
        "
        class="caret"
        [style.top.px]="inputHeight ? '0' : '10'"
        [style.right.px]="inputHeight ? '7' : '10'"
        [class.wallet-color]="hoverWalletEffect"
      >
        @if (!isDashboard) {
          <svg
            width="12"
            height="10"
            viewBox="0 0 12 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M6.00787 9C7.36059 9 11.6848 2.34803 10.9072 1.59336C10.1296 0.838686 1.96048 0.766564 1.10857 1.59336C0.256657 2.4212 4.65623 9 6.00787 9Z"
              [attr.fill]="inputDisabled ? '#979797' : '#679EC6'"
              [attr.stroke]="inputDisabled ? '#979797' : '#679EC6'"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        }
        @if (isDashboard) {
          <svg
            width="9"
            height="8"
            viewBox="0 0 9 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.50551 7C5.45241 7 8.47934 2.01102 7.93502 1.44502C7.3907 0.879015 1.67234 0.824923 1.076 1.44502C0.47966 2.0659 3.55936 7 4.50551 7Z"
              fill="#679EC6"
              stroke="#679EC6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        }
      </span>
    }
    @if (!viewOnly && label) {
      <label
        class="selector-label"
        [class.custom-height]="inputHeight"
        [style.color]="customLabelColor"
        >{{ label }}</label
      >
    }
    <ng-template #dropdown>
      <div
        class="cai-select"
        [class.hidden]="!options?.length"
        [class.wallet-reg-selector]="hoverWalletEffect"
      >
        @if (showTotal) {
          <div class="cai-select-total">
            <span>TOTAL RESULTS ({{ options.length }})</span>
          </div>
        }

        <div class="cai-select-wrapper">
          <div class="cai-select-inner">
            @for (option of options; track option) {
              <div
                class="cai-select-item"
                [class.wallet-hover]="hoverWalletEffect"
                [class.active]="selected === option"
                (mousedown)="select(option)"
              >
                @if (showIcon) {
                  <span class="item-icon">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4.92447 4.90751C5.14018 4.48414 5.48439 4.13994 5.90775 3.92422C6.10527 3.82358 6.36604 3.75445 6.81991 3.71737C7.28254 3.67957 7.87678 3.67899 8.72923 3.67899L10.4263 3.67899C11.1958 3.67899 11.4583 3.68381 11.6971 3.74115C11.9267 3.79627 12.1462 3.88718 12.3475 4.01055C12.557 4.1389 12.746 4.32111 13.2901 4.8652L18.3896 9.9647C18.9923 10.5675 19.4121 10.9881 19.7125 11.3419C20.0072 11.6891 20.1427 11.9224 20.2112 12.1332C20.3581 12.5851 20.3581 13.0719 20.2112 13.5238C20.1427 13.7346 20.0072 13.9679 19.7125 14.315C19.4121 14.6689 18.9923 15.0895 18.3896 15.6923L16.6925 17.3893C16.0897 17.9921 15.6691 18.4119 15.3153 18.7123C14.9681 19.007 14.7348 19.1425 14.524 19.211C14.0721 19.3578 13.5853 19.3578 13.1334 19.211C12.9226 19.1425 12.6893 19.007 12.3422 18.7123C11.9883 18.4119 11.5677 17.9921 10.9649 17.3893L5.86545 12.2898C5.32135 11.7457 5.13915 11.5567 5.01079 11.3472C4.88743 11.1459 4.79652 10.9265 4.7414 10.6969C4.68405 10.458 4.67923 10.1955 4.67923 9.42604V7.72899C4.67923 6.87653 4.67981 6.2823 4.71761 5.81967C4.7547 5.36579 4.82383 5.10503 4.92447 4.90751ZM5.22677 2.58771C4.52116 2.94724 3.94748 3.52092 3.58796 4.22652C3.36162 4.67074 3.26726 5.15088 3.22259 5.69752C3.17922 6.22842 3.17922 6.88403 3.17923 7.69686L3.17923 7.69688L3.17923 7.72899L3.17923 9.42604L3.17921 9.51151C3.17903 10.1631 3.1789 10.6141 3.28284 11.047C3.37471 11.4297 3.52622 11.7955 3.73183 12.131C3.96449 12.5107 4.28349 12.8295 4.74435 13.2901L4.80479 13.3505L9.90428 18.45L9.92698 18.4727C10.5017 19.0475 10.9653 19.511 11.3714 19.8558C11.7895 20.2107 12.1958 20.4835 12.6699 20.6376C13.4231 20.8823 14.2344 20.8823 14.9875 20.6376C15.4617 20.4835 15.8679 20.2107 16.286 19.8558C16.6921 19.511 17.1557 19.0475 17.7305 18.4727L17.7532 18.45L19.4502 16.7529L19.4729 16.7302C20.0477 16.1555 20.5113 15.6919 20.856 15.2858C21.211 14.8677 21.4838 14.4615 21.6378 13.9873C21.8825 13.2341 21.8825 12.4228 21.6378 11.6697C21.4838 11.1955 21.211 10.7893 20.856 10.3712C20.5113 9.96509 20.0477 9.50151 19.4729 8.92675L19.4502 8.90404L14.3507 3.80454L14.2903 3.7441L14.2903 3.74409C13.8297 3.28324 13.5109 2.96424 13.1312 2.73159C12.7957 2.52598 12.4299 2.37446 12.0473 2.2826C11.6143 2.17865 11.1633 2.17878 10.5118 2.17897L10.4263 2.17899L8.72923 2.17899L8.69714 2.17899L8.69713 2.17899C7.88429 2.17898 7.22867 2.17897 6.69776 2.22235C6.15113 2.26701 5.67099 2.36137 5.22677 2.58771ZM9.04304 9.29327C9.04304 8.60292 9.60268 8.04327 10.293 8.04327C10.9834 8.04327 11.543 8.60292 11.543 9.29327C11.543 9.98363 10.9834 10.5433 10.293 10.5433C9.60268 10.5433 9.04304 9.98363 9.04304 9.29327ZM10.293 6.54327C8.77425 6.54327 7.54304 7.77449 7.54304 9.29327C7.54304 10.8121 8.77425 12.0433 10.293 12.0433C11.8118 12.0433 13.043 10.8121 13.043 9.29327C13.043 7.77449 11.8118 6.54327 10.293 6.54327Z"
                        fill="#A566FF"
                        fill-opacity="0.63"
                      />
                    </svg>
                  </span>
                }
                <div
                  class="d-flex align-items-center"
                  [class.fixed-width]="secondaryTextLabel"
                >
                  @if (showCurrencyIcon) {
                    <span
                      class="item-icon d-flex align-items-center bg-transparent"
                    >
                      <div
                        class="currency-flag currency-flag-img-size"
                        [ngClass]="
                          'currency-flag-' +
                          getFlagName(option.value)?.toLowerCase()
                        "
                      ></div>
                    </span>
                  }
                  @if (showCurrencyIcon) {
                    <span
                      [title]="option.label"
                      [class.currency-label]="isCurrencySelector"
                      [class.active]="selected === option"
                      >{{ option.label }}</span
                    >
                  }
                </div>
                @if (showCurrencyIcon && option.secondaryText) {
                  <span
                    title="{{ secondaryTextLabel }} {{ option.secondaryText }}"
                    class="secondary-label"
                    >{{ secondaryTextLabel }} {{ option.secondaryText }}</span
                  >
                }
                @if (!showCurrencyIcon && !avoidTitleCase) {
                  <span [title]="option.label" [style.color]="fontColor">{{
                    option.label | titlecase
                  }}</span>
                }
                @if (!showCurrencyIcon && avoidTitleCase) {
                  <span [title]="option.label" [style.color]="fontColor">{{
                    option.label
                  }}</span>
                }
                @if (showLabelIcon) {
                  <img class="option-icon ms-2" [src]="option.labelIcon" />
                }
              </div>
            }
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  @if (!viewOnly && showError && errorMessage) {
    <span class="error-msg">
      {{ errorMessage }}
    </span>
  }
</div>
